var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllusCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.3,
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "url(#paint0_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "BG_2",
    opacity: 0.3,
    d: "M64.2064 112C90.7161 112 112.206 90.5097 112.206 64C112.206 37.4903 90.7161 16 64.2064 16C37.6968 16 16.2064 37.4903 16.2064 64C16.2064 90.5097 37.6968 112 64.2064 112Z",
    fill: "url(#paint1_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "human"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.151 58.6357C100.151 65.6721 94.4283 71.3763 87.3692 71.3763C80.31 71.3763 74.5874 65.6721 74.5874 58.6357C74.5874 51.5992 80.31 45.895 87.3692 45.895C94.4283 45.895 100.151 51.5992 100.151 58.6357ZM80.9878 99.5351C84.846 100.144 91.78 101.239 96.016 101.41H96.0199C100.092 101.576 104.207 98.2622 103.701 91.04C102.74 77.3447 94.3574 73.9296 85.2977 72.4549C76.2224 71.0656 67.1938 71.7292 62.0274 84.4582C59.3059 91.1681 62.1909 95.5883 66.1153 96.6866C70.1818 97.8286 77.096 98.9205 80.9598 99.5307L80.9878 99.5351Z",
    fill: "url(#paint2_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2375 56.3885C69.2375 60.2657 66.0843 63.4089 62.1945 63.4089C58.3048 63.4089 55.1515 60.2657 55.1515 56.3885C55.1515 52.5113 58.3048 49.3682 62.1945 49.3682C66.0843 49.3682 69.2375 52.5113 69.2375 56.3885ZM74.2511 71.032C74.2528 71.0316 74.2545 71.0312 74.2561 71.0309L74.2522 71.0347C74.2519 71.0338 74.2515 71.0329 74.2511 71.032ZM74.2511 71.032C71.8876 65.1435 67.3136 64.4491 62.6268 64.7207C57.877 65.0428 53.3685 66.3351 51.8229 72.7151C54.0888 73.1226 56.0899 73.891 57.8692 75.0281C59.7341 76.2156 61.342 77.7873 62.7241 79.7743C64.4061 76.9452 66.4228 74.7952 68.8289 73.2623C70.4588 72.2231 72.2559 71.4823 74.2511 71.032Z",
    fill: "url(#paint3_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.962 68.8152C63.962 69.4068 63.4809 69.8863 62.8874 69.8863C62.294 69.8863 61.8129 69.4068 61.8129 68.8152C61.8129 68.2237 62.294 67.7441 62.8874 67.7441C63.4809 67.7441 63.962 68.2237 63.962 68.8152ZM64.2384 73.1615C64.2384 73.753 63.7573 74.2326 63.1638 74.2326C62.5704 74.2326 62.0893 73.753 62.0893 73.1615C62.0893 72.5699 62.5704 72.0904 63.1638 72.0904C63.7573 72.0904 64.2384 72.5699 64.2384 73.1615Z",
    fill: "#E3E9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6405 61.1698C52.6405 67.8226 47.2299 73.2157 40.5556 73.2157C33.8814 73.2157 28.4708 67.8226 28.4708 61.1698C28.4708 54.5169 33.8814 49.1238 40.5556 49.1238C47.2299 49.1238 52.6405 54.5169 52.6405 61.1698ZM60.1622 97.5021C60.9876 97.2887 61.7663 96.92 62.4554 96.4077H62.4515C61.6105 95.682 60.9136 94.7894 60.4036 93.7494C59.4537 91.8284 58.7217 88.5608 60.6178 83.8883C61.0032 82.9375 61.412 82.0372 61.848 81.1911C56.9853 73.6896 49.7632 73.2705 42.4827 74.2406C33.8902 75.4631 25.905 78.5367 24.7331 91.4675C24.1258 98.2821 27.949 101.492 31.8034 101.41C35.7961 101.333 42.3412 100.43 46.0081 99.9249L46.0451 99.9198L46.2661 99.8891C49.9646 99.3756 56.3614 98.4873 60.1622 97.5021Z",
    fill: "url(#paint4_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2937 81.2221C45.2937 82.2359 44.4692 83.0577 43.4521 83.0577C42.4351 83.0577 41.6106 82.2359 41.6106 81.2221C41.6106 80.2083 42.4351 79.3865 43.4521 79.3865C44.4692 79.3865 45.2937 80.2083 45.2937 81.2221ZM46.3214 88.6305C46.3214 89.6443 45.4969 90.4661 44.4799 90.4661C43.4628 90.4661 42.6383 89.6443 42.6383 88.6305C42.6383 87.6167 43.4628 86.7949 44.4799 86.7949C45.4969 86.7949 46.3214 87.6167 46.3214 88.6305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0682 79.8135C86.0682 80.8851 85.1967 81.7539 84.1215 81.7539C83.0464 81.7539 82.1748 80.8851 82.1748 79.8135C82.1748 78.7418 83.0464 77.873 84.1215 77.873C85.1967 77.873 86.0682 78.7418 86.0682 79.8135ZM84.8267 87.6253C84.8267 88.697 83.9551 89.5657 82.88 89.5657C81.8048 89.5657 80.9332 88.697 80.9332 87.6253C80.9332 86.5536 81.8048 85.6849 82.88 85.6849C83.9551 85.6849 84.8267 86.5536 84.8267 87.6253Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upgrade"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M109.815 43.7756C102.625 43.7756 96.7731 37.9422 96.7731 30.7756C96.7731 23.609 102.625 17.7756 109.815 17.7756C117.005 17.7756 122.857 23.609 122.857 30.7756C122.857 37.9422 117.005 43.7756 109.815 43.7756Z",
    fill: "url(#paint5_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9731 30.7756C97.9731 37.2759 103.284 42.5756 109.815 42.5756C116.346 42.5756 121.657 37.2759 121.657 30.7756C121.657 24.2754 116.346 18.9756 109.815 18.9756C103.284 18.9756 97.9731 24.2754 97.9731 30.7756ZM96.7731 30.7756C96.7731 37.9422 102.625 43.7756 109.815 43.7756C117.005 43.7756 122.857 37.9422 122.857 30.7756C122.857 23.609 117.005 17.7756 109.815 17.7756C102.625 17.7756 96.7731 23.609 96.7731 30.7756Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.733 26.212L114.657 27.9931H114.652C115.006 28.3146 114.774 28.9048 114.293 28.9048H112.664V34.617C112.664 34.9226 112.416 35.1703 112.109 35.1703H107.526C107.219 35.1703 106.971 34.9226 106.971 34.617V28.9048H105.343C104.861 28.9048 104.629 28.3198 104.983 27.9931L106.907 26.212L109.461 23.8513C109.662 23.6616 109.979 23.6616 110.18 23.8513L112.733 26.212ZM105.787 36.166H113.849C114.278 36.166 114.626 36.5128 114.626 36.9406V37.0566C114.626 37.4844 114.278 37.8312 113.849 37.8312H105.787C105.358 37.8312 105.01 37.4844 105.01 37.0566V36.9406C105.01 36.5128 105.358 36.166 105.787 36.166Z",
    fill: "#CDFFF5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "protect"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.9706 59.929C8.60817 59.929 4.74556 57.3199 3.12774 53.2818C2.0755 50.6641 2.11496 47.7928 3.22858 45.2013C4.34659 42.6097 6.40723 40.6038 9.03345 39.5593C10.2961 39.0567 11.6158 38.8032 12.9618 38.8032C17.3242 38.8032 21.1868 41.4123 22.8047 45.4504C24.9705 50.8564 22.3224 57.014 16.899 59.1773C15.6363 59.6799 14.3166 59.9333 12.9706 59.9333V59.929Z",
    fill: "url(#paint6_linear_2455_8301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9706 59.9333C13.0726 59.9333 13.1745 59.9319 13.2762 59.929C13.5759 59.9204 13.8741 59.8992 14.1706 59.8654C15.101 59.7594 16.014 59.5295 16.899 59.1773C22.3224 57.014 24.9705 50.8564 22.8047 45.4504C21.1868 41.4123 17.3242 38.8032 12.9618 38.8032C11.6158 38.8032 10.2961 39.0567 9.03345 39.5593C6.40723 40.6038 4.34659 42.6097 3.22858 45.2013C2.11496 47.7928 2.0755 50.6641 3.12774 53.2818C4.74557 57.3199 8.60817 59.929 12.9706 59.929V59.9333ZM16.4544 58.0627C21.264 56.1443 23.6089 50.6844 21.6907 45.8966L22.8047 45.4504L21.6907 45.8966C20.2559 42.3154 16.8355 40.0032 12.9618 40.0032C11.7688 40.0032 10.5997 40.2274 9.47722 40.6742L9.47692 40.6743C7.14712 41.6009 5.32312 43.3761 4.33079 45.6757C3.34289 47.9753 3.30876 50.5147 4.24116 52.8343L4.24167 52.8356C5.67647 56.4168 9.09693 58.729 12.9706 58.729H13.2585C14.3514 58.6958 15.4226 58.4732 16.4544 58.0627Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9828 44.3181C14.6368 45.0086 12.5236 45.1921 11.0636 44.6065C10.406 46.0312 8.74867 47.3554 7.29745 47.775C8.70483 55.6108 15.2331 55.0033 15.2331 55.0033C15.2331 55.0033 20.3803 50.9565 15.9828 44.3137V44.3181Z",
    fill: "#FFE7C7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "decor",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.3514 119.883C81.4905 119.883 80.67 119.514 80.1032 118.866C79.5743 118.267 79.3125 117.495 79.3637 116.696C79.415 115.897 79.774 115.168 80.3758 114.639C80.9237 114.159 81.6254 113.894 82.3514 113.894C83.2124 113.894 84.0329 114.264 84.5996 114.912C85.1286 115.511 85.3904 116.283 85.3391 117.082C85.2879 117.881 84.9289 118.609 84.327 119.138C83.7792 119.619 83.0774 119.883 82.3514 119.883Z",
    fill: "#C79E61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.3878 17.7756C28.0315 17.7756 26.739 17.1933 25.8419 16.1732C24.1242 14.2223 24.3155 11.2343 26.2713 9.5171C27.1344 8.76053 28.2398 8.34399 29.3836 8.34399C30.7399 8.34399 32.0324 8.9263 32.9295 9.9464C34.6472 11.8973 34.4559 14.8854 32.5001 16.6025C31.637 17.3591 30.5315 17.7756 29.3878 17.7756Z",
    fill: "#FFB93E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M121.129 64.571C123.143 64.571 124.777 62.9377 124.777 60.923C124.777 58.9082 123.143 57.2749 121.129 57.2749C119.114 57.2749 117.48 58.9082 117.48 60.923C117.48 62.9377 119.114 64.571 121.129 64.571Z",
    fill: "#22B6A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2455_8301",
    x1: 63.9965,
    y1: 127.993,
    x2: 63.9965,
    y2: 26.1404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EA2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2455_8301",
    x1: 64.2038,
    y1: 111.995,
    x2: 64.2038,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EA2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE0FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2455_8301",
    x1: 84.1271,
    y1: 35.0281,
    x2: 77.6092,
    y2: 109.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469602,
    stopColor: "#5689FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493161,
    stopColor: "#9CBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#165DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2455_8301",
    x1: 63.0389,
    y1: 79.7726,
    x2: 63.0389,
    y2: 49.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C9FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2455_8301",
    x1: 37.9747,
    y1: 33.8881,
    x2: 48.8869,
    y2: 122.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436354,
    stopColor: "#7AA4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448938,
    stopColor: "#A2BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#296AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2455_8301",
    x1: 96.9951,
    y1: 45.8202,
    x2: 115.94,
    y2: 23.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11888F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31DBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2455_8301",
    x1: 12.9628,
    y1: 38.8032,
    x2: 12.9628,
    y2: 59.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB93E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A32B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusCommunity);
export default __webpack_public_path__ + "static/media/illus_community.d3316e321dd11a44efaeb9730a858fa3.svg";
export { ForwardRef as ReactComponent };